'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { AdditionalSettingsArticleList, BlockProps, ComponentBaseProps } from '@sola/schema/lib/schema.ts';
import { ArticleControls } from '../../../molecules/article-group/article-controls.tsx';
import { ArticleTabs, ArticleTabsSkeleton } from '../../../molecules/article-group/article-tabs.tsx';
const queryClient = new QueryClient();
export type ArticleListCoreProps = BlockProps & ComponentBaseProps & {
  hasTabs?: boolean;
};
export const ArticleListCore: React.FC<ArticleListCoreProps> = t0 => {
  const $ = _c(10);
  const {
    seoLevel: t1,
    settings,
    hasTabs: t2
  } = t0;
  const seoLevel = t1 === undefined ? 2 : t1;
  const hasTabs = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== settings) {
    t3 = settings ? AdditionalSettingsArticleList.parse(settings) : undefined;
    $[0] = settings;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const articleListSettings = t3;
  let t4;
  if ($[2] !== articleListSettings?.articleType || $[3] !== articleListSettings?.country || $[4] !== articleListSettings?.limit || $[5] !== articleListSettings?.theme || $[6] !== articleListSettings?.topic || $[7] !== hasTabs || $[8] !== seoLevel) {
    t4 = <section className="ArticleListCore component component--no-header"><div className="ArticleListCore__container container">{hasTabs ? <Suspense fallback={<ArticleTabsSkeleton />}><QueryClientProvider client={queryClient}><ArticleTabs seoLevel={seoLevel} articleType={articleListSettings?.articleType} topic={articleListSettings?.topic} country={articleListSettings?.country} theme={articleListSettings?.theme} limit={articleListSettings?.limit || 12} /></QueryClientProvider></Suspense> : <ArticleControls seoLevel={seoLevel} articleType={articleListSettings?.articleType} topic={articleListSettings?.topic} country={articleListSettings?.country} theme={articleListSettings?.theme} limit={articleListSettings?.limit || 12} />}</div></section>;
    $[2] = articleListSettings?.articleType;
    $[3] = articleListSettings?.country;
    $[4] = articleListSettings?.limit;
    $[5] = articleListSettings?.theme;
    $[6] = articleListSettings?.topic;
    $[7] = hasTabs;
    $[8] = seoLevel;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};